export enum TaskStatuses {
  PENDING = 'pending',
  DONE = 'done',
}
